export default function Hero() {
  return (
    <div className="relative h-[400px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=modern%20luxury%20residential%20building%20exterior%20with%20clean%20architecture%20blue%20sky%20background%20professional%20real%20estate%20photography%20wide%20angle%20view%20contemporary%20apartment%20complex%20with%20glass%20balconies%20and%20landscaped%20surroundings%20bright%20daylight%20minimalist%20design%20high%20quality%20architectural%20photo&width=1920&height=800&seq=about-hero-bg&orientation=landscape"
        alt="KARE YAPI İNŞAAT Projesi"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      
      <div className="relative z-10 text-center text-white px-4">
        <nav className="flex items-center justify-center gap-2 text-sm mb-4">
          <a href="/" className="hover:text-teal-400 transition-colors whitespace-nowrap">Ana Sayfa</a>
          <span>/</span>
          <span className="text-teal-400 whitespace-nowrap">Hakkımızda</span>
        </nav>
        <h1 className="text-5xl md:text-6xl font-bold mb-4">KARE YAPI İNŞAAT Hakkında</h1>
        <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto">
          Küçükçekmece'de modern yaşamın adresi
        </p>
      </div>
    </div>
  );
}